export const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    maxWidth: '98vw',
    bgcolor: "#1e1e1e",
    boxShadow: 8,
    p: 4,
    borderRadius: 2,
    border: "1px solid #444",
    maxHeight: '98vh',
    overflow: 'auto'
  };
  
  export const cellStyle = {
    width: 'max-content',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '200px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '4px',
    paddingBottom: '4px',
    fontSize: '13px',
  };
  
  export const stickyHeaderCellStyle = {
    ...cellStyle,
    fontWeight: 'bold',
  };

  export const buttonStyle = {
    backgroundColor: '#EBEBEB',
    color: '#000',
    textTransform: 'none',
    fontWeight: 500,
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(90deg, #d5d5d5 0%, #ffffff 100%)',
      color: '#000',
      transform: 'scale(1.03)',
    },
  };
  
  